'use client';

import { useEffect, useRef } from 'react';
import dynamic from 'next/dynamic';

// Dynamically import the legacy App to avoid SSR issues
const LegacyApp = dynamic(() => import('@/legacy-spa/App').then((mod) => ({ default: mod.App })), {
  ssr: false,
  loading: () => <div></div>,
});

export function LegacySPAWrapper() {
  const mountRef = useRef(false);

  useEffect(() => {
    // Prevent double mounting in React StrictMode
    if (!mountRef.current) {
      mountRef.current = true;
    }
  }, []);

  return <LegacyApp />;
}
